<template>
    <div class="banner banner--theme banner--study">
        <div class="banner-primary">
            <div class="container study-container">

                <div class="col-content">
                    <div class="banner-content">
                        <h1>{{data.title}}</h1>
                        <p v-html="data.content"></p>
                        
                       <div v-if="isTypeUndefined(data.solutionSets)" class="info--wrap">
                            <div class="info">
                                <div v-if="solutionSetsArray.length>0" class="info-wrapper item-count-multiple">
                                    <div v-for="solution in solutionSetsArray" class="info-icon info-icon--category">
                                        <a :href="solution.link">
                                            <div class="products-wrapper">
                                                <div v-if="solution.hex" class="products aa" :style="'background-color:' + solution.hex"></div>
                                                <div v-else class="products bb" :style="'background-image: url(' + solution.icon + ')'"></div>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{solution.name}}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                                <div 
                                    v-else
                                    v-for="solutionSet in data.solutionSets" 
                                    :key="solutionSet.id" 
                                    class="info-wrapper solution-sets"
                                    :class="[
                                        solutionSetsClass
                                    ]"
                                >
                                    <div v-if="solutionSet.data.solution.exists" class="info-icon info-icon--category">
                                        <a :href="solutionSet.data.solution.link">
                                            <div class="products-wrapper solution">
                                                <div class="products" :style="'background-image: url(' + solutionSet.data.solution.icon + ')'"></div>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{solutionSet.data.solution.name}}</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-if="solutionSet.data.profile.exists" class="info-icon info-icon--category">
                                        <a :href="solutionSet.data.profile.link">
                                            <div class="products-wrapper profile">
                                                <div class="products" :style="'background-image: url(' + solutionSet.data.profile.icon + ')'"></div>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{solutionSet.data.profile.name}}</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-if="solutionSet.data.colour.exists" class="info-icon">
                                        <a :href="solutionSet.data.colour.link" >
                                            <div class="products-wrapper colour">
                                                <div class="products" :style="'background-color:' + solutionSet.data.colour.hex"></div>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{solutionSet.data.colour.name}}</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-if="solutionSet.data.usecase.exists" class="info-icon info-icon--category">
                                        <a :href="solutionSet.data.usecase.link">
                                            <div class="products-wrapper usecase">
                                                <div class="products" :style="'background-image: url(' + solutionSet.data.usecase.icon + ')'"></div>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{solutionSet.data.usecase.name}}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <a v-if="data.primaryLink" class="button button--solid-black banner-study-cta" :href="data.primaryLink" :aria-label="data.primaryLabel" :title="data.primaryLabel">{{data.primaryLabel}}</a>
                        <a v-if="data.secondaryLink" class="button button--clear-black banner-study-cta" :href="data.secondaryLink" :aria-label="data.secondaryLabel" :title="data.secondaryLabel">{{data.secondaryLabel}}</a>
                    </div>
                </div>

                <div class="col-image">
                    <PinButton v-if="data.showPinterestButton"
                        :imageURL="data.image"
                        :imageDescription="data.imageTitle"
                    ></PinButton>

                    <div class="project-image" :style="{ backgroundImage: data.image ? 'url(' + data.image + ')' : 'initial' }">
                        <FavButton v-if="data.showFavButton" :imageID="data.imageID"></FavButton>
                    </div>

                    <div class="project-details imagecontent-details" v-html="data.imagecontent">
                    </div>
                    <div class="project-details" v-if="data.detailsOdd" :class="'count-' + data.detailsOdd.length">
                        <div class="project-details--col" v-if="data.detailsOdd">
                            <div class="item-row" v-for="detail in data.detailsOdd" :key="detail.id">
                                <strong >{{detail.type}}:</strong> 
                                <span>{{detail.details}}</span>
                            </div>
                        </div>
                        <div class="project-details--col" v-if="data.detailsEven">
                            <div class="item-row" v-for="detail in data.detailsEven" :key="detail.id">
                                <strong >{{detail.type}}:</strong> 
                                <span>{{detail.details}}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import FavButton from "../FavButton/FavButon";
import ColourCard from "../../components/Cards/ColourCard";
import PinButton from "../../components/PinButton/PinButton";

export default {
    name: "banner-study",
    components: {
        ColourCard,
        PinButton,
        FavButton,
    },
    methods: {
        isTypeUndefined(target){
            let returned = true;
            if(typeof target==='undefined') {
                returned = false;
            }else{
                if(typeof target.forEach==='function' && target.length<=0){
                    returned = false;
                }
            }
            return returned;
        },
        countObjects(items){
            let count = 0;

            if(items?.data?.colour?.exists) count++;
            if(items?.data?.profile?.exists) count++;
            if(items?.data?.solution?.exists) count++;
            if(items?.data?.usecase?.exists) count++;
            
            return count;
        }
    },
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            solutionSetsClass: 'item-count-single',
            solutionSetsArray: null
        };
    },
    created() {
        const obj = {
            colour: [],
            profile: [],
            solution: [],
            usecase: []
        }
        let combined = [];

        if(JSON.stringify(this.data.solutionSets) !== '[]'){
            const solutionsArray = this.convertItemsObjToArray(this.data.solutionSets);
            const countFirstSet = this.countObjects(solutionsArray[0]);

            if(countFirstSet>1){
                solutionsArray.forEach((solution, index) => {
                    if(solution.data.colour.exists) obj.colour.push(solution.data.colour);
                    if(solution.data.profile.exists) obj.profile.push(solution.data.profile);
                    if(solution.data.solution.exists) obj.solution.push(solution.data.solution);
                    if(solution.data.usecase.exists) obj.usecase.push(solution.data.usecase); // fix typo
                })
            }

            combined = combined.concat(obj.solution);
            combined = combined.concat(obj.profile);
            combined = combined.concat(obj.colour);
            combined = combined.concat(obj.usecase);

            this.solutionSetsArray = combined;
        }

        this.solutionSetsArray = combined;
    }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";
@import "../../../scss/abstracts/mixins";

.banner--study {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    min-height: 530px; // CS-217 adjusted
    margin-bottom: 2rem;

    @media #{$lg} {
        //max-height: 380px;
    }

    .container {
        display: block;

        @media #{$lg} {
            display: flex;

            &.study-container{
                // width: 100vw;
                // padding-left: 7.2916666667vw;
                // padding-right: 0vw;
            }
        }

        


        .col-content {
            width: 100%;
            display: block;

            @media #{$lg} {
                width: 45%;
                display: flex;
            }

            .banner-content {
                max-width: 100%;
                margin-top: 0;
                padding-right: 0;

                @media #{$lg} {
                    max-width: 650px;
                    margin-top: 130px;
                    padding-right: 2rem;
                }
            }
        }

        .col-image {
            width: 100vw;
            width: var(--vw-100);

            position: relative;
            bottom: 0;
            min-height: 0;
            overflow: hidden;

            right: auto;
            left: -2rem;

            @media #{$sm} {
                left: ($grid-gutter-base+$grid-col-base) * (-1);
                left: calc(((var(--vw-100) - #{$grid-container-inner-width}) / 2) * (-1) );
            }

            @media #{$lg} {
                left: auto;
                right: ($grid-gutter-base+$grid-col-base) * (-1);
                right: calc(((var(--vw-100) - #{$grid-container-inner-width}) / 2) * (-1) );

                width: 55%;
                position: relative;
                min-height: calc(100% - 130px);
                max-height: calc(100% - 130px);
                margin: auto;
                margin-top:130px;
            }

            

            .project-image {
                width: 100%;
                height: 0px;
                padding-bottom: 54.478%;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
            }
            
            .project-details {
                display: block;
                border-bottom: 1px solid;
                padding: 2rem 0;
                flex-direction: row;

                margin-left:  7.2916666667vw;
                width: calc(100% - 14.58333vw);
                


                @media #{$lg} {
                   display: flex;
                   margin-left: 0;
                   width: 100%;
                }

                &:last-child{
                    // margin-bottom: 60px;

                }

                &.count-0{
                    display: none;

                }

                &:empty{

                    display: none;
                }

                .project-details--col {
                    line-height: 34px;
                    margin-right: 1rem;
                    
                    &:empty{

                    display: none;
                    }

                    &:first-of-type {
                        margin-right: 3rem;

                        @media (max-width: 1199px) {
                            margin-right: 2rem;
                        }
                    }

                    .item-row {
                        display: flex;

                        > span,
                        > strong {
                            display: block;
                        }

                        > strong {
                            width: 125px;
                            padding-right: 15px;

                            @media (min-width: 768px) {
                                flex-shrink: 0;
                            }

                            @media (max-width: 767px) {
                                width: auto;
                                padding-right: 20px;
                            }
                        }
                    }
                }


                &.imagecontent-details{
                    border-bottom: none;
                    padding: 0;

                    p {
                        margin: 0;
                    }

                }
            }
        }
    }

    .banner-primary {
        .container {
            .col-content {
                height: auto;
                padding: 120px 0 2rem 0;

                @media #{$lg} {
                    padding: 0;
                }
            }
        }
    }
}





.info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 20px;

    // .info-wrapper{
    //     display: inline-flex;
    // }

    .info-wrapper {
        // width: 20%;
        &.item-count-multiple {
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .info-icon {
                width: 25%;
                max-width: 100%;

                @media (max-width:1199px) {
                    width: 33.333333333%;
                }

                a {
                    .products-wrapper {
                        // margin: 1rem auto;
                        // padding: 0 0.5rem;
                        // max-width: 70px;

                        // @media #{$sm} {
                        //     padding: 0 1rem;
                        //     max-width: 90px;
                        // }
                        // @media #{$lg} {
                        //     padding: 0 1rem;
                        //     max-width: 110px;
                        // }
                    }
                }
            }
        }

        &.item-count-single {
            width: 20%;

            @media (max-width:767px) {
                width: 33.333333333%;
            }
        }
    }

    .info-icon {
        width: auto;
        text-align: center;
        // margin: 0 1rem;
        max-width: 100px;

        //  @media #{$lg} {
        //      width: 100px;
        //  }

        

        a {
            display: block;

            > .info {
                padding-left: 5px;
                padding-right: 5px;
            }
        }

        .products-wrapper {
            position: relative;
            display: block;
            
            margin: 1rem auto;
            padding: 0 0.5rem;
            max-width: 70px;

            @media #{$sm} {
                padding: 0 1rem;
                max-width: 90px;
            }
            @media #{$lg} {
                padding: 0 1rem;
                max-width: 110px;
            }
        }
        .products {
            // width: 40px;
            // height: 40px;
            display: block;
            width: 100%;
            height: 0;
            padding-bottom: 100%;

            background: transparent;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 100%;
            
            @media #{$sm} {
                // width: 60px;
                // height: 60px;
             }

            @media #{$lg} {
                // width: 80px;
                // height: 80px;
             }


        }
       
    }

    .title{
                width: 100%;
                text-align: center;
                font-weight: bold;
                // font-size: 12px;
                @include font-size(12);

                @media #{$sm} {
                 font-size: 14px;

                }

    }

}

.banner-study-cta{
        display:block;
        margin : 0 auto;
        max-width: 210px;
        margin-bottom:10px;

        @media #{$lg} {
                display: inline-block;
                margin-right: 2rem;


        }

 }
</style>